const SESSION_VARIABLES = {
  ACCESS_TOKEN: "atoken",
  ADMIN_USER_ID: "adminUserId",
  ADMIN_USER_PROFILE_IMG: "picture",
  ADMIN_USER_EMAIL: "email",
  ADMIN_USER_NAME: "name",
};

export { SESSION_VARIABLES };
